import { useState } from "react";
import { Form, Button, Input, Upload, Image } from "antd";
import ImgCrop from "antd-img-crop";
import { config } from "../../../config";

const OrganizationSettings = ({ organization }) => {
  const [dirty, setDirty] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const submit = (values) => {
    console.log(values);
    setDirty(false);
    setSubmitting(false);
  };

  return (
    <Form
      initialValues={organization}
      layout="vertical"
      onFinish={submit}
      onValuesChange={() => setDirty(true)}
    >
      <Form.Item name="OrganizationName" label="Organization Name">
        <Input />
      </Form.Item>
      <Form.Item
        name="Subdomain"
        label="Sub domain"
        extra="Access Carisity on a custom URL: acme.oneedify.com"
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="LogoUrl"
        label="Organization Logo"
        extra="Your logo will be used on the login page for your employees"
      >
        <div style={{ border: "1px solid #dedede", padding: "20px" }}>
          <ImgCrop grid aspect={2}>
            <Upload
              beforeUpload={(file) => {
                return false;
              }}
            >
              <Image
                preview={false}
                src={
                  organization?.LogoUrl &&
                  `${config.imageUrl}/${organization.LogoUrl}`
                }
              />
              <Button type="dashed">Upload</Button>
            </Upload>
          </ImgCrop>
        </div>
      </Form.Item>
      <Form.Item>
        <Button
          disabled={!dirty || submitting}
          htmlType="submit"
          type="primary"
        >
          Save
        </Button>
      </Form.Item>
    </Form>
  );
};

export default OrganizationSettings;
